import React, { useState, useContext } from 'react';
import { AuthContext } from '../Auth/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TextField from "@mui/material/TextField";
import { Button, Alert, Snackbar } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import styles from "../styles/Login.css";

function Login() {
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const navigate = useNavigate()
    const auth = useContext(AuthContext);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setError(false);
    };
    
  
    const secondary = '#B08E44';
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
  
    const login = async (e) => {
        sessionStorage.clear();
        e.preventDefault();
        try {
            const response = await axios.post('https://api.sigmasystems.com.br/api/odontoluzzi/login', {
                email,
                senha,
            },{
                headers:{'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',}});
    
            const data = response.data;
            
            if (data.token) {
                auth.login(data.token);
                navigate('/Admin'); 
            } else {
                alert('Login falhou!');
            }
        } catch (error) {
            setError(true);
            setErrorText('Usuário ou Senha Inválida!');
        }
    };
  
    return (
      <div className='bg-login'>
        <div className="loginContainer">
          <div className="loginContent">
            <img className='logoLogin' src='https://odontoluzzi.com.br/images/logoLogin.svg'></img>
            <div className='formLogin'>
              <TextField 
                  id="outlined-basic"
                  placeholder='Usuário'
                  variant="outlined"
                  sx={{width:300, backgroundColor:'#fff',borderRadius:1}}
                  color='gold'
                  value={email}
                  onChange={e => setEmail(e.target.value)}
              />
              <FormControl sx={{width:300, marginTop:1, backgroundColor:'#fff',borderRadius:1}}
                  color="gold" variant="outlined" value={senha} onChange={e => setSenha(e.target.value)}>
                  <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                      <InputAdornment position="end">
                          <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                          >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                      </InputAdornment>
                      }
                      placeholder='Senha'
                  />
              </FormControl>
              <Button onClick={login} variant="contained" sx={{backgroundColor:secondary, width:300, height:56, fontFamily:'Montserrat', fontSize:18, '&:hover': {backgroundColor:secondary}, marginTop:2}}>entrar</Button>
              <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                    <Alert
                    onClose={handleClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                    >
                    {errorText}
                    </Alert>
                </Snackbar>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default Login;
  